import { api } from './api';
import { userLoginSuccess } from '../reducers/userInfo/slice';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { token, user } = data;
          dispatch(userLoginSuccess({ ...user, token }));
        } catch (_error) {
          // Handle login error if necessary
        }
      },
    }),
    forgetPassword: builder.mutation({
      query: ({ email }) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body: { email },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    changePassword: builder.mutation({
      query: (credentials) => ({
        url: '/auth/change-password',
        method: 'POST',
        body: credentials,
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, ...credentials }) => ({
        url: `/auth/reset-password/${token}`,
        method: 'POST',
        body: credentials,
      }),
    }),
    sendOtp: builder.mutation({
      query: ({ ...props }) => ({
        url: '/auth/send-otp',
        method: 'POST',
        body: { ...props },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
    }),
    verifyOtp: builder.mutation({
      query: ({ ...props }) => ({
        url: '/auth/verify-otp',
        method: 'POST',
        body: { ...props },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { token, user } = data;
          dispatch(userLoginSuccess({ ...user, token }));
        } catch (_error) {
          // Handle verify OTP error if necessary
        }
      },
    }),
    register: builder.mutation({
      query: (payload) => ({
        url: '/auth/register',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
    }),
    getUserInfo: builder.query({
      query: (id) => `/auth/${id}`,
      providesTags: ['User'],
    }),
    myBrandInfo: builder.query({
      query: (id) => `/brands/user/${id}`,
    }),
    getAllBrands: builder.query({
      query: (id) => '/brands',
    }),
    getMySeller: builder.query({
      query: ({ id, page = 1, limit = 10, search = '' }) =>
        `/brands/${id}/sellers?page=${page}&limit=${limit}&search=${search}`,
      providesTags: ['Seller'],
    }),
    applyForBrands: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/sellers/${id}/apply-for-brands`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useLoginUserMutation,
  useForgetPasswordMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useRegisterMutation,
  useLogoutMutation,
  useGetUserInfoQuery,
  useMyBrandInfoQuery,
  useGetAllBrandsQuery,
  useGetMySellerQuery,
  useApplyForBrandsMutation,
  useChangePasswordMutation,
  useResetPasswordMutation,
} = authApi;
